import React, { useState, useEffect } from 'react';
import { initPlasmicLoader } from '@plasmicapp/loader-react';

// Inizializzazione diretta del loader Plasmic
const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: "d2MsgnpGAMakcCHXnHqjaY",
      token: "wIZDUjtJL6SVOv6gb9BFG8I8eSQ6UL4j31TJc6LF8nZom3fLlvFIa3uVJRvT773Sm4sLDZmpbXvCuAmW85ig"
    }
  ],
  preview: true
});

function PlasmicExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [components, setComponents] = useState([]);

  useEffect(() => {
    // Verifica la connessione con Plasmic
    PLASMIC.fetchComponentData()
      .then(data => {
        console.log("Dati Plasmic caricati:", data);
        setComponents(Object.keys(data.entryCompMetas || {}));
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Errore nel caricamento dei dati Plasmic:", err);
        setError(err.message);
        setIsLoading(false);
      });
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Integrazione con Plasmic</h1>

      {isLoading ? (
        <p>Caricamento dei componenti Plasmic in corso...</p>
      ) : error ? (
        <div>
          <h3>Si è verificato un errore nella connessione con Plasmic:</h3>
          <p style={{ color: 'red' }}>{error}</p>
          <p>Verifica che:</p>
          <ul>
            <li>L'ID del progetto sia corretto</li>
            <li>Il token API sia valido</li>
            <li>Ci sia almeno un componente pubblicato nel progetto Plasmic</li>
          </ul>
        </div>
      ) : components.length === 0 ? (
        <div>
          <h3>Connessione a Plasmic riuscita!</h3>
          <p>Non ci sono ancora componenti pubblicati nel tuo progetto Plasmic.</p>
          <p>Vai su <a href="https://studio.plasmic.app/" target="_blank" rel="noopener noreferrer">Plasmic Studio</a> e crea il tuo primo componente.</p>
        </div>
      ) : (
        <div>
          <h3>Componenti disponibili:</h3>
          <ul>
            {components.map(comp => (
              <li key={comp}>{comp}</li>
            ))}
          </ul>
          <p>Per visualizzare un componente, usa:</p>
          <pre>{'<PlasmicComponent component="NomeComponente" />'}</pre>
        </div>
      )}
    </div>
  );
}

export default PlasmicExample;
